export default __webpack_public_path__ + "static/media/ea_results.c96d0c30.png";